import { render, staticRenderFns } from "./PopsFolderInfra.vue?vue&type=template&id=05ade702&scoped=true"
import script from "./PopsFolderInfra.vue?vue&type=script&lang=js"
export * from "./PopsFolderInfra.vue?vue&type=script&lang=js"
import style0 from "./PopsFolderInfra.vue?vue&type=style&index=0&id=05ade702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ade702",
  null
  
)

export default component.exports